import type {GridPoint, ImagePoint, LevelGeometryDocument, LevelTransition, WorldPoint} from "@/dungeons/model/DungeonGeometry.ts";
import {gridToWorld, imageToWorld, worldToImage} from "./Coordinates.ts";
import {transitionAreaCenter} from "./TransitionPolygon.ts";

export function defaultTransitionArrivalImagePosition(points: readonly GridPoint[],
    source: LevelGeometryDocument, target: LevelGeometryDocument): ImagePoint {
    const world = gridToWorld(transitionAreaCenter(points), source.grid);
    const image = worldToImage(world, target);
    const round = (value: number) => Math.round(value * 10_000) / 10_000;
    return {x: round(image.x), y: round(image.y)};
}

export function transitionArrivalWorld(transition: LevelTransition, target: LevelGeometryDocument): WorldPoint | undefined {
    return transition.arrivalImagePosition
        ? imageToWorld(transition.arrivalImagePosition, target) : undefined;
}

export function transitionArrivalOnSourceImage(transition: LevelTransition,
    source: LevelGeometryDocument, target: LevelGeometryDocument): ImagePoint | undefined {
    const world = transitionArrivalWorld(transition, target);
    return world ? worldToImage(world, source) : undefined;
}
